import React, { useContext, useEffect, useState } from "react";
import { Tabs, Tab } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { MyContext } from "../../../MyContextApi";

const NavigationTabs = ({ tabConfig }) => {
  const { settoggleAdduser, setsidebarPlatformName } = useContext(MyContext);
  const navigate = useNavigate();
  const location = useLocation();

  const activeTabSet =
    tabConfig.find((config) => config.routes.includes(location.pathname)) ||
    tabConfig[0];

  const { routes, labels, defaultRoute } = activeTabSet;

  const routeIndex = routes.indexOf(location.pathname);
  const defaultIndex = routes.indexOf(defaultRoute);

  // 👇 New state for controlling tab index
  const [selectedTab, setSelectedTab] = useState(
    routeIndex === -1 ? defaultIndex : routeIndex
  );

  // 👇 Update selected tab when route changes (adds animation opportunity)
  useEffect(() => {
    setSelectedTab(routeIndex === -1 ? defaultIndex : routeIndex);
  }, [location.pathname, routeIndex, defaultIndex]);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue); // allow animation
    navigate(routes[newValue]);
    const platformName = routes[newValue].replace("/", "").toUpperCase();
    handlePlatformChange(false, platformName);
  };

  const handlePlatformChange = (isAddUser, platform) => {
    settoggleAdduser(isAddUser);
    setsidebarPlatformName(platform);
  };

  return (
    <div className="navigation-tabs">
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="inherit"
        variant="fullWidth"
        sx={{
          ".MuiTabs-indicator": {
            backgroundColor: "#4F7DF3",
            height: "2px",
            transition: "all 0.3s ease-in-out", // <- Ensure smooth transition
          },
        }}
      >
        {labels.map((label, index) => (
          <Tab
            key={label}
            label={label}
            onClick={() => {
              const platformName = routes[index].replace("/", "").toUpperCase();
              handlePlatformChange(false, platformName);
            }}
            sx={{
              fontFamily: "'Host Grotesk', sans-serif",
              textTransform: "none",
              fontWeight: 700,
              color: "rgba(255, 255, 255, 0.65)",
              transition: "all 0.2s ease-in-out",
              "&.Mui-selected": {
                color: "#FFFFFF",
              },
              "&:hover": {
                fontWeight: 700,
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                color: "rgba(255, 255, 255, 0.9)",
              },
              whiteSpace: "nowrap",
              minWidth: "120px",
              padding: "12px 16px",
            }}
          />
        ))}
      </Tabs>
    </div>
  );
};

export default NavigationTabs;
